/**
 * useCanChat — the ONE definition of who is in the Clubhouse.
 *
 * Signed in, not anonymous, and carrying a claimed handle: the same three
 * conditions `postChatMessage` enforces server-side, because a UI that offers
 * an action the callable will reject is just a slower error message.
 *
 * It lives in its own hook rather than inside {@link ChatDock} because the
 * presence rail needs the identical answer for its wave button. Asking a
 * different question there — "is the dock's provider mounted?" — rendered a
 * wave for logged-out visitors that opened a dock which then refused to render.
 */
import { useAuth, useMyProfile } from '../services/context.js';

export function useCanChat(): boolean {
  const { user } = useAuth();
  const { profile } = useMyProfile();
  return Boolean(user?.uid && !user.isAnonymous && profile?.handle);
}
